(function (window, document) {
	'use strict';

	const defaultOptions = {
		durationCssVariable: '--navigation-transition-duration',
		groupSelector: '.navigation__group',
		groupItemSelector: '.navigation__group-item',
		groupItemActivateClass: 'navigation__group-item--activate',
		groupItemActivatedClass: 'navigation__group-item--active',
		groupItemDeactivateClass: 'navigation__group-item--deactivate',
		groupItemExpandableClass: 'navigation__group-item--parent',
		itemSelector: '.navigation-item',
		itemActiveClass: 'navigation-item--active',
		closeOnEscapeMouse: true,
	};

	function Navigation(element, options) {

		// Mische die übergebenen Optionen mit den Standardoptionen
		this.options = Object.assign({}, defaultOptions, options);

		// Speichere das DOM-Element, auf das das Plugin angewendet wird
		this.element = element;

		// Derzeit per Maus geoeffnet
		this.mouseActive = false;

    // Flag um eine direkte Reaktivierung von Navigationspunkten (Mausbewegung wenn Timeout zum Schliessen noch nicht durch ist)
    // verhindern
    this.forceDeactivate = false;

		// Plugin intern initialisieren
		this.boot();
	}

	Navigation.prototype.boot = function() {
		const _ = this;

		// // alle Navigationspunkte nach Typ kennzeichen (Direktlink / Unternavigation)
		// _.element.querySelectorAll(_.options.itemSelector).forEach(function(item) {
		//
		// 	// hat mindestens Unterelement
		// 	if(item.querySelector(_.options.groupSelector) !== null) {
		// 		item.classList.add('navigation-item--expandable');
		// 		// item.setAttribute('aria-expanded', false);
		//
		// 	} else {
		// 		item.classList.add('navigation-item--link');
		// 	}
		//
		// 	// Event vorbereiten
		// 	mint.fireEvent('navigation.item.initialize', {navigation: _, item: item});
		// });

		// Focus nicht mehr im Container
		if(_.options.closeOnEscapeMouse === true) {
			document.addEventListener('keydown', function(event) {
				if(event.code === 'Escape' && _.mouseActive === true) {
          _.initializeForceDeactivate();
					_.deactivateAll();
				}
			});
		}

		// in Sonderfaellen = schnelle Mausbewegung ist die Animation noch nicht abgeschlossen
		// dann oeffnet sich die Navigation nach dem Verlassen des Navigationspunktes
		// -> in diesem Fall schliessen des aktiven Navigationspunktes erneut feuern
		_.element.addEventListener('mouseleave', function(event) {
			setTimeout(function() {
				if(_.mouseActive === false) {
					_.deactivateAll();
				}
			}, _.getDuration());
		});

		_.element.querySelectorAll(_.options.groupItemSelector).forEach(function(groupItem) {
			const navigationItem = groupItem.querySelector(_.options.itemSelector);
			// let item = link.parentElement;
			// let mouseActive = false;
			// let active = false;
			// 	let timeout = false;
			//
			// 	if(listItem.hasAttribute('aria-expanded') === true) {
			// 		let svg = mint.createSvgUseElement('#sprite-chevron-right', {'viewBox': '0 0 6 12'});
			// 		item.appendChild(svg);
			// 	}
			//
			// link.addEventListener('click', function(event) {
			// 	mint.fireEvent('navigation.link.click', {navigation: _, item: item, link: link, originalEvent: event});
			// });
			//
      groupItem.addEventListener('mouseleave', function(event) {
        if(_.mouseActive === true) {
          _.mouseActive = false;
          mint.fireEvent('navigation.link.mouseout', {navigation: _, groupItem: groupItem, item: navigationItem, originalEvent: event}, _.element);
        }
      });

			groupItem.addEventListener('mousemove', function(event) {
				if(_.mouseActive === false && _.forceDeactivate === false) {
					_.mouseActive = true;
					mint.fireEvent('navigation.link.mousemove', {navigation: _, groupItem: groupItem, item: navigationItem, originalEvent: event}, _.element);
				}
			});
			//
			// 	listItem.addEventListener('focusin', function(event) {
			// 		if(navigation.isMobileEnabled() === false) {
			// 			timeout = false;
			// 			navigation.itemExpand(item, listItem);
			// 		}
			// 	});
			//
			// 	listItem.addEventListener('focusout', function(event) {
			// 		timeout = true;
			//
			// 		setTimeout(function() {
			// 			if(timeout === true) {
			// 				// navigation.itemReduce(item, listItem);
			// 			}
			// 		}, 10);
			// 	});
		});
	}

  Navigation.prototype.initializeForceDeactivate = function() {
    const _ = this;

    _.forceDeactivate = true;

    // Duration * 2 -> um wirklich eine vollstaendige Deaktivierung sicher zu stellen
    setTimeout(function() {
      _.forceDeactivate = false;
    }, (_.getDuration() * 2));
  }

	Navigation.prototype.getDuration = function() {
		let duration = parseInt(getComputedStyle(this.element).getPropertyValue(this.options.durationCssVariable));

		if(isNaN(duration) === true) {
			duration = 0;
		}

		return duration;
	}

	Navigation.prototype.itemExpandable = function(item) {
		if(item.querySelector(this.options.groupSelector) !== null) {
      return true;
    }

    return false;
	}

	Navigation.prototype.createParentLink = function(item, link) {
		let _ = this;

		let parentItem = document.createElement('li'),
			parentLink = link.cloneNode(true);
		// svg = mint.createSvgUseElement('#sprite-overview', {'viewBox': '0 0 11 12'});

		parentItem.classList.add('navigation__item', 'navigation__item--parentlink');

		// link.removeChild(link.querySelector('svg'));

		// nur wenn das Elternelemet ein Link ist
		// if(link.tagName.toLocaleLowerCase() === 'a') {
		// 	link.appendChild(svg);
		// }

		parentItem.appendChild(parentLink);

		return parentItem;
	}

	Navigation.prototype.createBackLink = function(parentItem, link) {
		let _ = this,
			backListItem = document.createElement('li'),
			backButton = document.createElement('button');
		// svg = mint.createSvgUseElement('#sprite-arrow-left', {'viewBox': '0 0 14 11'});

		backButton.classList.add('navigation__backlink');
		backButton.innerText = mint.l10n.navigation.prev;
		backButton.addEventListener('click', function() {
			_.itemReduce(parentItem, backListItem);
		});

		backListItem.classList.add('navigation__item', 'navigation__item--backlink');
		backListItem.appendChild(backButton);

		return backListItem;
	}

	Navigation.prototype.itemBeforeExpand = function(item, link) {
		// let _ = this;
		//
		// // Erstellung Parent Link
		// // als erstes -> Zurueck-Link wird ebenfalls an erster Stelle eingefuegt und verdraengt den Link
		// if(item.querySelector('.navigation__item--parentlink') === null) {
		// 	item.querySelector('ul').insertAdjacentElement('afterbegin', _.createParentLink(item, link));
		// }
		//
		// // Erstellung Zurueck Link
		// if(item.querySelector('.navigation__item--backlink') === null) {
		// 	item.querySelector('ul').insertAdjacentElement('afterbegin', _.createBackLink(item, link));
		// }
	}

	Navigation.prototype.itemActivate = function(item, link) {
		const _ = this;
		const transistionDuration = _.getDuration();
		// const transistionDuration = 0;

		// nur wenn es Kind Elemente gibt
		if(_.itemExpandable(item) === true && item.classList.contains(_.options.groupItemActivatedClass) === false) {

			// Backlink und Direktlink einbinden
			_.itemBeforeExpand(item, link);

			item.classList.add(_.options.groupItemActivateClass);

			mint.fireEvent('navigation.item.activate', {
				navigation: _,
				link: link
			}, item);

			setTimeout(function() {
        if(item.classList.contains(_.options.groupItemDeactivateClass) === false) {
          item.classList.add(_.options.groupItemActivatedClass);
          item.classList.remove(_.options.groupItemActivateClass);

          mint.fireEvent('navigation.item.activated', {
            navigation: _,
            link: link
          }, item);
        }
			}, transistionDuration);
		}
	}

	Navigation.prototype.itemDeactivate = function(item, link, force) {
		const _ = this;
		const transistionDuration = _.getDuration();

		item.classList.add(_.options.groupItemDeactivateClass);
		item.classList.remove(_.options.groupItemActivatedClass);

    if(force === true) {
      _.initializeForceDeactivate();
    }

		mint.fireEvent('navigation.item.deactivate', {
			navigation: _,
			link: link
		}, item);

		setTimeout(function() {
			item.classList.remove(_.options.groupItemDeactivateClass);

			mint.fireEvent('navigation.item.deactivated', {
				navigation: _,
				link: link
			}, item);
		}, transistionDuration);
	}

	Navigation.prototype.deactivateAll = function() {
		const _ = this;
    const active = this.getActiveItems();

    if(active !== null) {
      this.getActiveItems().forEach(function(groupItem) {
        mint.fireEvent('navigation.link.mouseout', {
            navigation: _,
            groupItem: groupItem,
            item: groupItem.querySelector(_.options.itemSelector)},
          _.element);
      });
    }

    _.mouseActive = false;
	}

  Navigation.prototype.getActiveItems = function() {
    if(this.element.querySelector('.' + this.options.groupItemActivatedClass)) {
      return this.element.querySelectorAll('.' + this.options.groupItemActivatedClass);
    }

    return null;
  }

	function initialize(element, options) {
		return new Navigation(element, options);
	}

	mint.components.navigation = initialize;
})(window, document);
